export default {
  currencyConvert: (state) => {
    return state.currencyConvert
  },
}
